import { render } from "./person-change-password.vue?vue&type=template&id=435f5dba"
import script from "./person-change-password.vue?vue&type=script&lang=js"
export * from "./person-change-password.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__